import React from 'react';
import classNames from 'classnames';
import { RangeSlider } from '../RangeSlider';
import './TimeSliders.less';

export interface ITimeSliderValue {
  hours: number;
  minutes: number;
}

interface ITimeSlidersProps {
  hours: number;
  minutes: number;
  onChange: (config: ITimeSliderValue) => void;
  children?: React.ReactNode;
}

const getClassName = () => classNames('dpc-time-sliders');

const MAX_HOURS = 23;
const MAX_MINUTES = 59;

/**
 * Sliders for Hours/Minutes
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function TimeSliders({ hours, minutes, onChange, children }: ITimeSlidersProps) {
  const onHoursChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updateHours = parseInt(e.target.value, 10) || 0;
    const validHours = updateHours > MAX_HOURS ? MAX_HOURS : updateHours;
    onChange({ hours: validHours, minutes });
  };
  const onMinutesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedMinutes = parseInt(e.target.value, 10) || 0;
    const validMinutes = updatedMinutes > MAX_MINUTES ? MAX_MINUTES : updatedMinutes;
    onChange({ hours, minutes: validMinutes });
  };

  // TODO toggle AM/PM

  return (
    <div className={getClassName()}>
      <div className="dpc-time-sliders__fields">
        {children}
        <input
          className="dpc-time-sliders__field dpc-text-input-wrapper dpc-text-input dpc-text-input--hide-spinner"
          type="number"
          value={hours + ''}
          onChange={onHoursChange}
        />
        :
        <input
          className="dpc-time-sliders__field dpc-text-input-wrapper dpc-text-input dpc-text-input--hide-spinner"
          type="number"
          value={minutes + ''}
          onChange={onMinutesChange}
        />
      </div>
      <div className="dpc-time-sliders__hours">
        <label className="dpc-time-sliders__label">Hours: </label>
        <RangeSlider
          id="hours"
          className="dpc-time-sliders__hours-slider"
          min={0}
          max={MAX_HOURS}
          value={hours}
          onChange={onHoursChange}
        />
      </div>
      <div className="dpc-time-sliders__minutes">
        <label className="dpc-time-sliders__label">Minutes: </label>
        <RangeSlider
          id="minutes"
          className="dpc-time-sliders__minutes-slider"
          min={0}
          max={55}
          step={5}
          value={minutes}
          onChange={onMinutesChange}
        />
      </div>
    </div>
  );
}
